import {AlignItemsType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/hvbox/AlignItemsType';
import {DirectionType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/hvbox/DirectionType';
import {DistributeType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/hvbox/DistributeType';
import {WrapType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/hvbox/WrapType';
import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {AStringEnumConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AEnumConfig';
import {CSSProperties} from 'react';

export class HVBoxParentModel
{
    @Property<DirectionType>({
        title: 'Direction',
        tip: 'Direction',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: DirectionType
    })
    public direction:DirectionType;

    @Property<DistributeType>({
        title: 'Distribute',
        tip: 'Distribute',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: DistributeType
    })
    public distribute:DistributeType;

    @Property<AlignItemsType>({
        title: 'Align Items',
        tip: 'Align Items',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: AlignItemsType
    })
    public alignItems:AlignItemsType;

    @Property<WrapType>({
        title: 'Wrap Distribute',
        tip: 'Wrap Distribute',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: WrapType
    })
    public wrap:WrapType;

    public constructor(direction:DirectionType = DirectionType.row(),
                       distribute:DistributeType = DistributeType.start(),
                       alignItems:AlignItemsType = AlignItemsType.start(),
                       wrap:WrapType = WrapType.noWrap())
    {
        this.direction = direction;
        this.distribute = distribute;
        this.alignItems = alignItems;
        this.wrap = wrap;
    }

    public toCss():CSSProperties
    {
        const css:CSSProperties = {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            flexWrap: 'nowrap',
            alignContent: 'flex-start'
        };

        if( DirectionType.isRowReversed(this.direction) )
            css.flexDirection = 'row-reverse';
        else if( DirectionType.isColumn(this.direction) )
            css.flexDirection = 'column';
        else if( DirectionType.isColumnReversed(this.direction) )
            css.flexDirection = 'column-reverse';

        if( DistributeType.isEnd(this.distribute) )
            css.justifyContent = 'flex-end';
        else if( DistributeType.isCenter(this.distribute) )
            css.justifyContent = 'center';
        else if( DistributeType.isSpaceBetween(this.distribute) )
            css.justifyContent = 'space-between';
        else if( DistributeType.isSpaceAround(this.distribute) )
            css.justifyContent = 'space-around';
        else if( DistributeType.isSpaceEvenly(this.distribute) )
            css.justifyContent = 'space-evenly';

        if( AlignItemsType.isStart(this.alignItems) )
            css.alignItems = 'flex-start';
        else if( AlignItemsType.isEnd(this.alignItems) )
            css.alignItems = 'flex-end';
        else if( AlignItemsType.isCenter(this.alignItems) )
            css.alignItems = 'center';

        if( WrapType.isStart(this.wrap) )
        {
            css.flexWrap = 'wrap';
            css.alignContent = 'flex-start';
        }
        else if( WrapType.isEnd(this.wrap) )
        {
            css.flexWrap = 'wrap';
            css.alignContent = 'flex-end';
        }
        else if( WrapType.isCenter(this.wrap) )
        {
            css.flexWrap = 'wrap';
            css.alignContent = 'center';
        }
        else if( WrapType.isSpaceBetween(this.wrap) )
        {
            css.flexWrap = 'wrap';
            css.alignContent = 'space-between';
        }
        else if( WrapType.isSpaceAround(this.wrap) )
        {
            css.flexWrap = 'wrap';
            css.alignContent = 'space-around';
        }
        else if( WrapType.isSpaceEvenly(this.wrap) )
        {
            css.flexWrap = 'wrap';
            css.alignContent = 'space-evenly' as any;
        }
        else if( WrapType.isStartReversed(this.wrap) )
        {
            css.flexWrap = 'wrap-reverse';
            css.alignContent = 'flex-start';
        }
        else if( WrapType.isEndReversed(this.wrap) )
        {
            css.flexWrap = 'wrap-reverse';
            css.alignContent = 'flex-end';
        }
        else if( WrapType.isCenterReversed(this.wrap) )
        {
            css.flexWrap = 'wrap-reverse';
            css.alignContent = 'center';
        }
        else if( WrapType.isSpaceBetweenReversed(this.wrap) )
        {
            css.flexWrap = 'wrap-reverse';
            css.alignContent = 'space-between';
        }
        else if( WrapType.isSpaceAroundReversed(this.wrap) )
        {
            css.flexWrap = 'wrap-reverse';
            css.alignContent = 'space-around';
        }
        else if( WrapType.isSpaceEvenlyReversed(this.wrap) )
        {
            css.flexWrap = 'wrap-reverse';
            css.alignContent = 'space-evenly' as any;
        }

        return css;
    }
}
